import React, { useState } from 'react';
import { IUserGroup } from '../Interfaces/IUserGroup';
import {
  Alert,
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from '@mui/material';
import { IUser } from '../Interfaces/IUser';
import { DataGrid, GridColDef, deDE } from '@mui/x-data-grid';
import { Add } from '@mui/icons-material';
import { UserGroupEdit } from './UserGroupEdit';
import { LoadingSpinner } from '../core/LoadingSpinner';
import {
  useGetUserGroups,
  useGetUsers,
} from '../hooks/reactQuerys/UserQueries';

const columns: GridColDef[] = [
  {
    field: 'idUserGroup',
    headerName: 'Nr.',
    width: 90,
  },
  {
    field: 'Email',
    headerName: 'E-Mail',
    width: 250,
  },
  {
    field: 'PhoneNumber',
    headerName: 'Rufnummer',
    width: 250,
  },
  {
    field: 'UserGroup',
    headerName: 'Gruppe',
    flex: 1,
  },
];

export const UserGroupOverview = () => {
  const { userGroups, isLoadingUserGroups } = useGetUserGroups();
  const { users, isLoadingUsers } = useGetUsers();

  if (isLoadingUserGroups || isLoadingUsers) {
    return <LoadingSpinner />;
  }

  if (!userGroups || !users) {
    return <Alert severity='error'>Fehler!</Alert>;
  }

  return <UserGroup initialUserGroups={userGroups} users={users} />;
};

export const UserGroup = ({
  initialUserGroups,
  users,
}: {
  initialUserGroups: IUserGroup[];
  users: IUser[];
}) => {
  const [userGroups, setUserGroups] = useState<IUserGroup[]>(initialUserGroups);
  const [idUserGroup, setIdUserGroup] = useState<number | null>(null);

  return (
    <>
      <Dialog
        open={idUserGroup !== null}
        onClose={() => setIdUserGroup(null)}
        maxWidth='md'
        fullWidth
      >
        <DialogContent>
          {idUserGroup !== null && (
            <UserGroupEdit
              idUserGroup={idUserGroup}
              setIdUserGroup={setIdUserGroup}
              userArray={users}
              userGroupArray={userGroups}
              setUserGroupArray={setUserGroups}
            />
          )}
        </DialogContent>
      </Dialog>

      <Box sx={{ m: 2, mt: 0 }}>
        <Typography variant='h4'>
          Benutzergruppen
          <IconButton
            sx={{ float: 'right' }}
            onClick={() => setIdUserGroup(-1)}
          >
            <Add />
          </IconButton>
        </Typography>

        <DataGrid
          localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
          rows={userGroups}
          columns={columns}
          getRowId={row => row.idUserGroup}
          onRowClick={params => setIdUserGroup(Number(params.id))}
          autoHeight
        />
      </Box>
    </>
  );
};
